import { apiRequest } from './index';

export const fetchHolidayRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/holidays/' + id, {}, success, failure);
}

export const fetchHolidaysRequest = ( area = '', success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(`/holidays?area=${area}`, {}, success, failure);
}

export const createHolidayRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/holidays',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editHolidayRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/holidays/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const deleteHolidayRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/holidays/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
